import { useEffect, useState } from 'react';
import TeamInsightsSettings from './TeamInsightsSettings';
import { loadTeamsSettings } from '../ChatTools/common';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { DefinitionLevels } from 'common/services/settings.service';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const TeamInsightsSettingsContainer = props => {
  const { selectedTeam } = props;
  const [teamSettings, setTeamSettings] = useState(null);
  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();

  useEffect(() => {
    loadTeamsSettings([selectedTeam]).then(res => {
      setTeamSettings(res);

      TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
        page: TRACKING.PAGES.SETTINGS,
        page_tab: TRACKING.PAGE_TABS.TEAM_INSIGHTS
      });
    });
  }, [selectedTeam]);

  const [
    isVisionNotificationsEnabledForTeam,
    setIsVisionNotificationsEnabledForTeam
  ] = useState(
    !!getSettingOrDefinitionValue({
      name: FEATURE_FLAGS_NAMES.isVisionNotificationsEnabledForTeam,
      definitionLevel: DefinitionLevels.TEAM,
      teamId: selectedTeam.id
    })
  );

  const updateTeamInsightSettings = checked => {
    updateSetting(
      FEATURE_FLAGS_NAMES.isVisionNotificationsEnabledForTeam,
      checked,
      DefinitionLevels.TEAM,
      selectedTeam.id,
      false
    ).then(() => {
      setIsVisionNotificationsEnabledForTeam(checked);
    });
  };

  return (
    <TeamInsightsSettings
      {...props}
      teamSettings={teamSettings}
      isVisionNotificationsEnabledForTeam={isVisionNotificationsEnabledForTeam}
      updateTeamInsightSettings={updateTeamInsightSettings}
    />
  );
};

export default TeamInsightsSettingsContainer;
